/* @jsx h */
import { h } from "vue";
import type { GridColumnDef } from "@lemmonhq/uikit";

/**
 * Grid column with a button that opens the recipe editor for the row.
 * Disabled for rows not saved yet (no real id), since recipes are saved
 * immediately against the product or extra.
 */
export function recipeColumn<T extends { id: number }>(
  t: (key: string) => string,
  onOpen: (row: T) => void,
): GridColumnDef<T> {
  return {
    key: "__recipe",
    header: t("inventory.recipe.column"),
    type: "readonly",
    width: 120,
    editable: false,
    bulkEditable: false,
    renderCell: (_value, row) => (
      <button
        type="button"
        class="btn btn-xs min-h-7 w-full justify-start gap-1.5 border-base-300 bg-base-100 px-2 shadow-none text-base-content/65 hover:text-primary"
        disabled={!(row.id > 0)}
        title={t("inventory.recipe.edit")}
        onClick={(event: MouseEvent) => {
          event.stopPropagation();
          onOpen(row);
        }}
      >
        <span class="material-symbols-outlined text-sm">soup_kitchen</span>
        <span class="truncate">{t("inventory.recipe.edit")}</span>
      </button>
    ),
  };
}
